import type { IconId } from '@/types/generated/icons';

import sprite from '@/assets/sprites/sprite.svg';
import { cn } from '@/lib/utils';

export interface SvgIconProps
  extends Omit<React.SVGProps<SVGSVGElement>, 'width' | 'height'> {
  name: IconId;
  size?: number;
  width?: number;
  height?: number;
}

export const SvgIcon = ({
  name,
  size = 16,
  width,
  height,
  ...props
}: SvgIconProps) => {
  return (
    <svg
      className={cn('inline-block shrink-0', props.className)}
      height={height ?? size}
      width={width ?? size}
      {...props}
    >
      <use href={`${sprite}#icon-${name}`} />
    </svg>
  );
};
